import links from "@/links/links";

export default {
  actions: {
    GET(id) {
      return this.get(links.MEETING_CORRESPONDENCE_VOTE_GET(id));
    },
    POST(item) {
      return this.post(links.MEETING_CORRESPONDENCE_VOTE_POST(), item);
    },    
    PUT(item) {
      return this.put(links.MEETING_CORRESPONDENCE_VOTE_PUT(item.id), item);
    },
  },
};
